<template>
  <section class="PersonalDetail_address" data-scroll="address">
    <div class="PersonalDetail_header flex-between">
      <h3 class="form_title">
        {{ $t('common.address.title.shipping', 'Shipping address') }}
      </h3>

      <app-edit-button
        :editable="editable"
        @click.native="editAddress"
        data-name="myAccountAddress-editButton"
        :disabled="updateAddressTask.isActive"
        v-if="ableToUpdateAddress"
      />
    </div>

    <div class="PersonalDetail_body MyAccountForm">
      <!-- shipping/shipping&billing address -->
      <section class="address-shipping flex flex-column">
        <div
          class="SelectGroup Form_group"
          :class="{'error': errorsFor('selectedCountry').length > 0}"
          v-if="countries.length > 1" >

          <label class="Form_label">
            {{ $t('common.address.textLable.country', 'Country') }}
          </label>
          <app-text-input
            v-if="!editable"
            class="no-border no-padding"
            :value="selectedCountry && selectedCountry.name"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-country"
          />
          <app-select
            v-if="editable"
            :placeholder="$t('common.address.placeholder.country', 'Select your country')"
            v-model="selectedCountry"
            :options="countries || []"
            :searchable="false"
            :allow-empty="false"
            :show-labels="false"
            open-direction="bottom"
            label="name"
            track-by="code"
            data-name="myAccountShippingAddress-selectcountry"
            :disabled="updateAddressTask.isActive"
          />
        </div>

        <template v-if="selectedCountry && (selectedCountry.code === 'GB' || selectedCountry.code === 'ES' || selectedCountry.code === 'BE' || selectedCountry.code === 'IT' || selectedCountry.code === 'AT' || selectedCountry.code === 'FR' || selectedCountry.code === 'SE' || selectedCountry.code === 'RO' || selectedCountry.code === 'CZ')">
          <app-text-input
            v-model.trim="line1"
            :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1*')"
            :errors="errorsFor('line1')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-AddressLine1"
            name="myAccountShippingAddress-AddressLine1"
            autocomplete="shipping street-address"
            autofocus="autofocus"
            required="required"
          />

          <app-text-input
            v-if="selectedCountry && (selectedCountry.code === 'ES' || selectedCountry.code === 'BE' || selectedCountry.code === 'IT' || selectedCountry.code === 'AT' || selectedCountry.code === 'FR' || selectedCountry.code === 'SE' || selectedCountry.code === 'RO' || selectedCountry.code === 'CZ')"
            :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
            v-model.trim="houseNumber"
            :errors="errorsFor('houseNumber')"
            data-name="myAccountShippingAddress-houseNumber"
            name="myAccountShippingAddress-houseNumber"
            autocomplete="shipping houseNumber"
            required="required"
            :disabled="!editable || updateAddressTask.isActive"
          />

          <app-text-input
           v-if="selectedCountry && (selectedCountry.code === 'ES' || selectedCountry.code === 'GB' || selectedCountry.code === 'FR' || selectedCountry.code === 'SE')"
            v-model.trim="line2"
            :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
            :errors="errorsFor('line2')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-AddressLine2"
            name="myAccountShippingAddress-AddressLine2"
            autocomplete="shipping address-line2"
          />

          <app-text-input
            v-model.trim="city"
            :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
            :errors="errorsFor('city')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-town"
            name="myAccountShippingAddress-addressLevel1"
            autocomplete="shipping address-level1"
            required="required"
          /> 
          
          <div
            v-if="selectedCountry && selectedCountry.code === 'GB'"
            class="SelectGroup Form_group"
            :class="{'error': errorsFor('county').length > 0}">
            <label class="Form_label">
              {{ $t('common.address.textLabel&placeholder.county', 'County*') }}
            </label>
            <app-text-input
              v-if="!editable"
              :value="county"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.textLabel&placeholder.county', 'County*')"
              v-model="county"
              :options="counties"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :disabled="updateAddressTask.isActive"
              :internal-search="false"
              @search-change="searchCounty"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
              {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
            </p>
          </div>

           <!-- <div
            v-if="selectedCountry && selectedCountry.code === 'ES' || selectedCountry && selectedCountry.code === 'IT'"
            class="SelectGroup Form_group"
            :class="{'error': errorsFor('stateCode').length > 0}">
            <label class="Form_label">
              {{ $t('common.address.textLabel&placeholder.Provincia', 'Provincia*') }}
            </label>
            <app-text-input
              v-if="!editable"
              :value="stateCode"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.textLabel&placeholder.Provincia', 'Provincia*')"
              v-model="stateCode"
              :options="counties"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :disabled="updateAddressTask.isActive"
              :internal-search="false"
              @search-change="searchCounty"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('county')" :key="index">
              {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
            </p>
          </div>    -->
         

          <app-text-input
            v-model.trim="zipCode"
            :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
            :errors="errorsFor('zipCode')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-zipCode"
            name="myAccountShippingAddress-zipCode"
            autocomplete="shipping postal-code"
            required="required"
          />
        </template>

        <template v-else>
          <div
            class="SelectGroup Form_group"
            v-if="selectedCountry && selectedCountry.states && currentCountryCode !== 'CA'"
            :class="{'error': errorsFor('selectedCountryState').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.state', 'State') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="selectedCountryState && selectedCountryState.name"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.state', 'Select your state')"
              v-model="selectedCountryState"
              :options="selectedCountry.states || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedCountry.code"
              @search-change="searchState"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryState')" :key="index">
              {{ $t('common.address.textLable.state', 'State') }} {{ error }}
            </p>
          </div>

          <div
            class="SelectGroup Form_group"
            v-if="countryProvinces && currentCountryCode === 'CA'"
            :class="{'error': errorsFor('selectedCountryProvince').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.province', 'Province') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="selectedCountryProvince && selectedCountryProvince.name"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.province', 'Select your province')"
              v-model="selectedCountryProvince"
              :options="countryProvinces.provinces || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedCountry.code"
              @search-change="searchProvince"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryProvince')" :key="index">
              {{ $t('common.address.textLable.province', 'Province') }} {{ error }}
            </p>
          </div>

          <app-text-input
            v-if="selectedCountry && selectedCountry.street_housenumber_extension_field === 1"
            :label="$t('common.address.textLabel&placeholder.address', 'Address')"
            v-model.trim="addition"
            :errors="errorsFor('addition')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-addition"
            autocomplete="shipping street-address"
            name="myAccountShippingAddress-street"
            autofocus="autofocus"
          />

          <app-text-input
            :class="{ 'order-1': currentCountryCode === 'PL'}"
            :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
            v-model.trim="zipCode"
            :errors="errorsFor('zipCode')"
            autocomplete="shipping postal-code"
            name="myAccountShippingAddress-zipCode"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountShippingAddress-zipCode"
            :autofocus="selectedCountry && selectedCountry.street_housenumber_extension_field === 3 ? 'autofocus' : false"
          />

          <template v-if="selectedCountry && selectedCountry.street_housenumber_extension_field === 3">
            <app-text-input
              :label="$t('common.address.textLabel&placeholder.street', 'Street')"
              v-model.trim="street"
              :errors="errorsFor('street')"
              :disabled="!editable || updateAddressTask.isActive"
              data-name="myAccountShippingAddress-street"
              autocomplete="shipping street-address"
              name="myAccountShippingAddress-street"
            />

            <app-text-input
              :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
              v-model.trim="houseNumber"
              :errors="errorsFor('houseNumber')"
              :disabled="!editable || updateAddressTask.isActive"
              data-name="myAccountShippingAddress-houseNumber"
            />

            <app-text-input
              :label="$t('common.address.textLabel&placeholder.extension', 'Extension')"
              v-model.trim="extension"
              :errors="errorsFor('extension')"
              :disabled="!editable || updateAddressTask.isActive"
              data-name="myAccountShippingAddress-extension"
            />
          </template>

          <app-text-input
            v-if="currentCountryCode !== 'CA'"
            :class="{ 'order-2': currentCountryCode === 'PL'}"
            :label="$t('common.address.textLabel&placeholder.city', 'City')"
            v-model.trim="city"
            :errors="errorsFor('city')"
            :disabled="!editable || updateAddressTask.isActive"
            autocomplete="shipping locality"
            name="myAccountShippingAddress-city"
            data-name="myAccountShippingAddress-city"
          />
          <div
            class="SelectGroup Form_group"
            v-if="countryProvinces && currentCountryCode === 'CA'"
            :class="{'error': errorsFor('selectedCountryCity').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.city', 'City') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="city"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.city', 'Select your city')"
              v-model="selectedCountryCity"
              :options="countryProvinces.cities || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedCountry.code"
              @search-change="searchCity"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedCountryProvince')" :key="index">
              {{ $t('common.address.textLable.city', 'City') }} {{ error }}
            </p>
          </div>
        </template>

        <app-checkbox
          class="no-border order-last"
          v-if="editable"
          id="billingAddress"
          :label="$t('common.address.checkbox.hasBilling.label', 'I have a different billing address')"
          :value="hasBillingAddress"
          @input="hasBillingAddress = $event"
          :disabled="!editable || updateAddressTask.isActive"
          @click="trackConversion({name: 'interaction', description: `different_billing_address:${hasBillingAddress ? 'uncheck': 'check'}`})"
        />
      </section>

      <!-- billing address -->
      <section class="address-billing flex flex-column" v-if="hasBillingAddress">
        <div class="PersonalDetail_header flex-between">
          <h3 class="form_title">
            {{ $t('common.address.title.billing', 'Billing address') }}
          </h3>
        </div>

        <div
          class="SelectGroup Form_group"
          :class="{'error': errorsFor('selectedBillingCountry').length > 0}"
          v-if="countries.length > 1" >

          <label class="Form_label">
            {{ $t('common.address.textLable.country', 'Country') }}
          </label>
          <app-text-input
            v-if="!editable"
            class="no-border no-padding"
            :value="selectedBillingCountry && selectedBillingCountry.name"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-country"
          />
          <app-select
            v-if="editable"
            :placeholder="$t('common.address.placeholder.country', 'Select your country')"
            v-model="selectedBillingCountry"
            :options="countries || []"
            :searchable="false"
            :allow-empty="false"
            :show-labels="false"
            open-direction="bottom"
            label="name"
            track-by="code"
            data-name="myAccountBillingAddress-selectcountry"
            :disabled="updateAddressTask.isActive"
          />
          <p class="tip-error" v-for="(error, index) in errorsFor('selectedBillingCountry')" :key="index">
            {{ $t('common.address.textLable.country', 'Country') }} {{ error }}
          </p>
        </div>

        <template v-if="selectedCountry && (selectedCountry.code === 'GB' || selectedCountry.code === 'ES' || selectedCountry.code === 'BE' || selectedCountry.code === 'IT' || selectedCountry.code === 'AT' || selectedCountry.code === 'FR' || selectedCountry.code === 'SE' || selectedCountry.code === 'CZ' || selectedCountry.code === 'RO')">
          <app-text-input
            v-model.trim="billingLine1"
            :label="$t('common.address.textLabel&placeholder.addressLine1', 'Address line 1*')"
            :errors="errorsFor('billingLine1')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-AddressLine1"
            name="myAccountBillingAddress-AddressLine1"
            autocomplete="billing street-address"
            autofocus="autofocus"
            required="required"
          />

          <app-text-input
            v-model.trim="billingHouseNumber"
            :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number*')"
            :errors="errorsFor('billingHouseNumber')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-houseNumber"
            name="myAccountBillingAddress-houseNumber"
            autocomplete="billing houseNumber"
            required="required"
          />

          <app-text-input
            v-if="selectedCountry && (selectedCountry.code === 'ES' || selectedCountry.code === 'GB' || selectedCountry.code === 'FR' || selectedCountry.code === 'SE')"
            v-model.trim="billingLine2"
            :label="$t('common.address.textLabel&placeholder.addressLine2', 'Address line 2 (additional address line)')"
            :errors="errorsFor('billingLine2')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-AddressLine2"
            name="myAccountBillingAddress-AddressLine2"
            autocomplete="billing address-line2"
          />

          <app-text-input
            v-model.trim="billingCity"
            :label="$t('common.address.textLabel&placeholder.town', 'Town*')"
            :errors="errorsFor('billingCity')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-town"
            name="myAccountBillingAddress-addressLevel1"
            autocomplete="billing address-level1"
            required="required"
          /> 

          <div
            v-if="selectedCountry && selectedCountry.code === 'GB'"
            class="SelectGroup Form_group"
            :class="{'error': errorsFor('billingCounty').length > 0}">
            <label class="Form_label">
              {{ $t('common.address.textLabel&placeholder.county', 'County*') }}
            </label>
            <app-text-input
              v-if="!editable"
              :value="billingCounty"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.textLabel&placeholder.county', 'County*')"
              v-model="billingCounty"
              :options="counties"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :disabled="updateAddressTask.isActive"
              :internal-search="false"
              @search-change="searchCounty"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('billingCounty')" :key="index">
              {{ $t('common.address.textLabel&placeholder.county', 'County*') }} {{ error }}
            </p>
          </div>
          
          <!-- <div
            v-if="selectedCountry && selectedCountry.code === 'ES' || selectedCountry && selectedCountry.code === 'IT'"
            class="SelectGroup Form_group"
            :class="{'error': errorsFor('billingStateCode').length > 0}">
            <label class="Form_label">
              {{ $t('common.address.textLabel&placeholder.Provincia', 'Provincia*') }}
            </label>
            <app-text-input
              v-if="!editable"
              :value="billingStateCode"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.textLabel&placeholder.Provincia', 'Provincia*')"
              v-model="billingStateCode"
              :options="counties"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              :disabled="updateAddressTask.isActive"
              :internal-search="false"
              @search-change="searchCounty"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('billingStateCode')" :key="index">
              {{ $t('common.address.textLabel&placeholder.Provincia', 'Provincia*') }} {{ error }}
            </p>
          </div> -->

          <app-text-input
            v-model.trim="billingZipCode"
            :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
            :errors="errorsFor('billingZipCode')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-zipCode"
            name="myAccountBillingAddress-zipCode"
            autocomplete="billing postal-code"
            required="required"
          />
        </template>

        <template v-else>
          <div
            class="SelectGroup Form_group"
            v-if="selectedBillingCountry && selectedBillingCountry.states && selectedBillingCountry.code !== 'CA'"
            :class="{'error': errorsFor('selectedBillingCountryState').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.state', 'State') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="selectedBillingCountryState && selectedBillingCountryState.name"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.state', 'Select your state')"
              v-model="selectedBillingCountryState"
              :options="selectedBillingCountry.states || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedBillingCountry.code"
              @search-change="searchState"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedBillingCountryState')" :key="index">
              {{ $t('common.address.textLable.state', 'State') }} {{ error }}
            </p>
          </div>

          <div
            class="SelectGroup Form_group"
            v-if="selectedBillingCountry && countryProvinces && selectedBillingCountry.code === 'CA'"
            :class="{'error': errorsFor('selectedBillingCountryProvince').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.province', 'Province') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="selectedBillingCountryProvince && selectedBillingCountryProvince.name"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.province', 'Select your province')"
              v-model="selectedBillingCountryProvince"
              :options="countryProvinces.provinces || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedBillingCountry.code"
              @search-change="searchProvince"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedBillingCountryProvince')" :key="index">
              {{ $t('common.address.textLable.province', 'province') }} {{ error }}
            </p>
          </div>

          <app-text-input
            v-if="selectedBillingCountry && selectedBillingCountry.street_housenumber_extension_field === 1"
            :label="$t('common.address.textLabel&placeholder.address', 'address')"
            v-model.trim="billingAddition"
            :disabled="!editable || updateAddressTask.isActive"
            :errors="errorsFor('billingAddition')"
            data-name="myAccountBillingAddress-addition"
            autocomplete="billing street-address"
            name="myAccountBillingAddress-addition"
            autofocus="autofocus"
          />

          <app-text-input
            :class="{ 'order-1': currentCountryCode === 'PL'}"
            :label="$t('common.address.textLabel&placeholder.zipCode', 'Zip code')"
            v-model.trim="billingZipCode"
            :errors="errorsFor('billingZipCode')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-zipCode"
            autocomplete="billing postal-code"
            name="myAccountBillingAddress-zipCode"
            :autofocus="selectedBillingCountry && selectedBillingCountry.street_housenumber_extension_field === 3 ? 'autofocus' : false"
          />

          <template v-if="selectedBillingCountry && selectedBillingCountry.street_housenumber_extension_field === 3">
            <app-text-input
              :label="$t('common.address.textLabel&placeholder.street', 'Street')"
              v-model.trim="billingStreet"
              :errors="errorsFor('billingStreet')"
              data-name="myAccountBillingAddress-street"
              :disabled="!editable || updateAddressTask.isActive"
              autocomplete="billing street-address"
              name="myAccountBillingAddress-street"
            />

            <app-text-input
              :label="$t('common.address.textLabel&placeholder.houseNumber', 'House number')"
              v-model.trim="billingHouseNumber"
              :errors="errorsFor('billingHouseNumber')"
              data-name="myAccountBillingAddress-houseNumber"
              :disabled="!editable || updateAddressTask.isActive"
            />

            <app-text-input
              :label="$t('common.address.textLabel&placeholder.extension', 'extension')"
              v-model.trim="billingExtension"
              :errors="errorsFor('billingExtension')"
              data-name="myAccountBillingAddress-extension"
              :disabled="!editable || updateAddressTask.isActive"
            />
          </template>

          <app-text-input
            v-if="currentCountryCode !== 'CA'"
            :class="{ 'order-2': currentCountryCode === 'PL'}"
            :label="$t('common.address.textLabel&placeholder.city', 'City')"
            v-model.trim="billingCity"
            :errors="errorsFor('billingCity')"
            :disabled="!editable || updateAddressTask.isActive"
            data-name="myAccountBillingAddress-city"
            autocomplete="billing locality"
            name="myAccountBillingAddress-city"
          />

          <div
            class="SelectGroup Form_group"
            v-if="selectedBillingCountry && countryProvinces && selectedBillingCountry.code === 'CA'"
            :class="{'error': errorsFor('selectedBillingCountryCity').length > 0}" >

            <label class="Form_label">
              {{ $t('common.address.textLable.city', 'City') }}
            </label>
            <app-text-input
              v-if="!editable"
              class="no-border no-padding"
              :value="billingCity"
              :disabled="!editable || updateAddressTask.isActive"
            />
            <app-select
              v-if="editable"
              :placeholder="$t('common.address.placeholder.city', 'Select your city')"
              v-model="selectedBillingCountryCity"
              :options="countryProvinces.billingCities || []"
              :searchable="true"
              :allow-empty="false"
              :show-labels="false"
              open-direction="bottom"
              label="name"
              track-by="code"
              :internal-search="false"
              :id="selectedBillingCountry.code"
              @search-change="searchBillingCity"
              :disabled="updateAddressTask.isActive"
            >
              <span slot="noResult">{{ $t('common.select.search.noResult', 'Not result') }}</span>
            </app-select>
            <p class="tip-error" v-for="(error, index) in errorsFor('selectedBillingCountryProvince')" :key="index">
              {{ $t('common.address.textLable.city', 'city') }} {{ error }}
            </p>
          </div>

        </template>
      </section>

      <app-button
        v-if="editable"
        type="submit"
        @click.prevent="updateAddressTask.run()"
        :is-loading="updateAddressTask.isActive"
        data-name="myAccountAddress-updateButton"
      >
        {{ $t('common.button.save', 'Save') }}
      </app-button>
    </div>
  </section>
</template>

<script>
  import PersonalAddressMixin from 'mixins/re-personal-address'

  export default {
    name: 'my-account-address',

    mixins: [PersonalAddressMixin]
  }
</script>

<style lang="scss">
  .PersonalDetail_address {
    margin-top: .35rem;

    .address-billing {
      margin-top: .28rem;
    }

    .multiselect--active {
      .multiselect__tags {
        .multiselect__input {
          width: 100% !important;
        }
      }
    }
  }
</style>
